import { useState } from 'react'

import { GetTaskConfigurationSignatureDocumentsDocument } from 'generated/resources/graphql'
import isNil from 'lodash/isNil'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSignatureDocuments = (taskConfigurationId?: string) => {
  const { data, loading } = useQuery(GetTaskConfigurationSignatureDocumentsDocument, {
    skip: isNil(taskConfigurationId),
    variables: {
      taskConfigurationId: taskConfigurationId!,
    },
  })

  const [filesToAdd, setFilesToAdd] = useState<File[]>([])
  const [filesToRemove, setFilesToRemove] = useState(new Set<string>())

  const currentFiles = data?.processes.taskConfigurationSignatureDocuments

  const onAddFiles = (files: File[]) => {
    setFilesToAdd(files)
    setFilesToRemove(new Set<string>(currentFiles?.map((file) => file.id)))
  }

  const onDeleteNewFile = (fileToDelete: File) => {
    setFilesToAdd(filesToAdd.filter((file) => file !== fileToDelete))
  }

  const onDeleteExistingFile = (file: { id: string }) => {
    setFilesToRemove(new Set<string>([...filesToRemove, file.id]))
  }

  return {
    loadingFiles: loading,
    currentFiles,
    filesToAdd,
    filesToRemove,
    onAddFiles,
    onDeleteNewFile,
    onDeleteExistingFile,
  }
}
